module.exports = __webpack_public_path__ + "static/media/1POLICY13.1a2e1cfc.jpg";